/** @jsx jsx */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import { Tooltip } from "@material-ui/core";
import { Translate } from "@material-ui/icons";
import { Fragment } from "react";
import TranslationsModal from "src/components/molecules/modals/TranslationsModal";
import {
  OnChangeTranslations,
  Translations,
} from "src/components/molecules/modals/TranslationsModal/types";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import { useBooleanState } from "src/hooks/utils";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";
import { PurposedButtonProps } from "./types";

type Props = PurposedButtonProps & {
  translations: Translations;
  onChangeTranslations: OnChangeTranslations;
};

const Button = styled.button`
  width: 35px;

  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;

  background-color: ${({ theme }) => theme.colors.secondaryColor};
  color: #fff;
  border: none;

  display: grid;
  place-items: center;

  &:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.2) 0 0);
    transition: background-image 0.2s ease-in-out;
  }

  svg {
    font-size: 20px;
  }
`;

const TranslationBtnWithModal = ({
  translations,
  onChangeTranslations,
  ...props
}: Props) => {
  const [isOpen, toggleIsOpen] = useBooleanState(false);
  const formatMsg = useFormatMsg();

  return (
    <Fragment>
      <Tooltip
        id="translate-tooltip"
        title={formatMsg("common.translation")}
        placement="top-end"
      >
        <Button
          data-cy="translation-button"
          type="button"
          onClick={toggleIsOpen}
        >
          <Translate />
        </Button>
      </Tooltip>
      {isOpen && (
        <TranslationsModal
          isOpen={isOpen}
          toggle={toggleIsOpen}
          translations={translations}
          onSave={onChangeTranslations}
        />
      )}
    </Fragment>
  );
};

export default TranslationBtnWithModal;
